import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public currentYear: any;

  constructor(private router: Router) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  onLinkClick(event: MouseEvent, path: string) {
    if ((event.ctrlKey || event.metaKey) && event.target instanceof HTMLAnchorElement) {

      const urlTree = this.router.createUrlTree([path]);
      const newTabUrl = '#' + this.router.serializeUrl(urlTree);

      window.open(newTabUrl, '_blank');


    }
  }

}
